import { SnackbarResource } from "../locales";

export const snackbar: SnackbarResource = {
    addToCartSuccess: "Handlekurven er oppdatert.",
};
